// extracted by mini-css-extract-plugin
export var avatarContainer = "_41-0";
export var gray = "_41-f";
export var green = "_41-c";
export var icon = "_41-9";
export var image = "_41-1";
export var lg = "_41-6";
export var md = "_41-5";
export var presenceDot = "_41-b";
export var red = "_41-d";
export var sm = "_41-4";
export var status = "_41-a";
export var xl = "_41-7";
export var xs = "_41-3";
export var xxl = "_41-8";
export var xxs = "_41-2";
export var yellow = "_41-e";